export default "__VITE_ASSET__C4vVa4kN__"